module.exports = __webpack_public_path__ + "static/media/valor2.ee1d5a5f.gif";